(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-new-template-packs"]) return;
  try {
    
$(document).ready(function ($) {
    const thumbnailsSlider = $('[data-product-thumbnails]');
    const mainSlider = $('[data-product-single-media-group]');
    thumbnailsSlider.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        vertical: false,
        asNavFor: mainSlider,
        focusOnSelect: true
    });
    mainSlider.slick({
        infinite: false,
        slidesToScroll: 1,
        asNavFor: thumbnailsSlider,
        arrows: false
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-new-template"]) return;
  try {
    
$(document).ready(function($) {
  const thumbnailsSlider = $('[data-product-thumbnails]');
  const mainSlider = $('[data-product-single-media-group]');
  thumbnailsSlider.slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    vertical: false,
    asNavFor: mainSlider,
    focusOnSelect: true
  });
  mainSlider.slick({infinite: false, slidesToScroll: 1, asNavFor: thumbnailsSlider, arrows: false});
});
  } catch(e) { console.error(e); }
})();
})();
